import React, { useEffect, useState } from "react";
import { fetchForm } from "../../api/forms";
import { fetchWebsiteSettings, updateWebsiteSettings } from "../../api/website";
import FormRenderer from "../../components/FormRenderer";

export default function Website() {
  const [form, setForm] = useState(null);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let active = true;
    Promise.all([fetchForm("website"), fetchWebsiteSettings()])
      .then(([nextForm, settings]) => {
        if (!active) return;
        setForm(nextForm);
        setValues(settings || {});
      })
      .catch((nextError) => active && setError(nextError?.message || "Unable to load website settings"))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setSaved(false);
    setError("");
    try {
      const result = await updateWebsiteSettings({ theme: values.theme });
      setValues(result || values);
      setSaved(true);
    } catch (nextError) {
      setError(nextError?.message || "Unable to save website settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <h1 className="mb-4">{form?.label || "Configure Website"}</h1>
      {error && <div className="alert alert-danger">{error}</div>}
      {saved && <div className="alert alert-success">Website settings saved.</div>}
      {form && (
        <form onSubmit={save}>
          <FormRenderer
            form={form}
            values={values}
            onChange={setValues}
            disabled={saving}
          />
          <button className="btn btn-primary" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </form>
      )}
    </div>
  );
}
